class slideHelper {
    constructor() {

    }
    glide(el) {

        var glide = new Glide('#' + el.id, {
            type: 'slider',
            perView: 3,
            autoplay: false,
            animationDuration: 400,
            gap: 40,
            peek: { before: 0, after: 200 },
            breakpoints: {
                1330: { perView: 2 },
            },

        });
        glide.mount();

        var glideId = el.id;

        var numOfSlides = document.getElementsByClassName('glide__slide').length;
        document.getElementById('prevglide' + glideId).disabled = true;

        glide.on(['mount.after', 'run'], function () {
            if (glide.index == 0) {
                document.getElementById('prevglide' + glideId).disabled = true;
            } else {
                document.getElementById('prevglide' + glideId).disabled = false;
            }
            if (glide.index == numOfSlides - 3) {
                document.getElementById('nextglide' + glideId).disabled = true;
            } else {
                document.getElementById('nextglide' + glideId).disabled = false;
            }
        });

        $('.show-hover').on('click', function (el) {
            var content = $(this).closest('.glide__slide');
            $(content).find('.case-study-card').addClass('show');
        })
    }
    singleGlide(el) {
        var glide = new Glide('.glider', {
            type: 'slider',
            perView: 1,
            autoplay: false,
            animationDuration: 400,

        }).mount();

        var glideId = el.id;

    }
    imageGallery() {
        $('.image-thumbnail').on('click', function () {
            var target = $(this).attr('data-target'), 
                mainImage = $('.main-image.show');
            
            mainImage.fadeOut();
            mainImage.removeClass('show');

            setTimeout(function () {
                $(target).fadeIn();
                $(target).addClass('show');
            }, 500)
        });
    }
}
window.app.add('slide', new slideHelper());